var $ = require('jquery');
var unavailable = require('../helpers/unavailable');
require('jquery-datepicker');

var Calendars = function Calendars() {
	var $calendar = $('.calendar');

	if($calendar.length) {
		var attrData = $calendar.attr('data-unavailable');
		var unavailableDates = false;

		if(attrData) unavailableDates = JSON.parse($calendar.attr('data-unavailable'));

		$calendar.find('.trigger').datepicker({
			minDate: 0,
			beforeShowDay: unavailable.bind(null, unavailableDates),
			numberOfMonths: ($calendar.length === 1) ? 2 : 1
		});
	}
}

module.exports = Calendars;